import React from 'react';
import InvestmentGraph from '../../../../assets/investment_graph2.svg';
import './InvestmentSection.css';

const InvestmentSection = () => {
    return (
        <div className="container investment__container row shadow-lg">
            <div className="col-md-6">
                <img src={InvestmentGraph} alt="investment-graph" className="w-100" />
            </div>
            <div className="col-md-6 d-flex flex-column justify-content-between investment__subSection align-items-start">
                <h3>
                    Total Investment sale from last year transaction
                </h3>
                <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit sed eiusmod tempor incididunt labore dolore magna aliqua minim Lorem ipsum dolor sit amet consectetur.
                </p>
                <div>
                    <button className="btn btn-primary">
                        Learn More
                    </button>
                </div>
            </div>
        </div>
    )
}

export default InvestmentSection
